module.exports = __webpack_public_path__ + "static/media/sidebar-7.0a2f81e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-7.jpg
// module id = 452
// module chunks = 0